import { cn } from '@/lib/utils';

interface ContentObligationsBadgeProps {
  count: number;
  onClick: () => void;
  className?: string;
}

export function ContentObligationsBadge({ count, onClick, className }: ContentObligationsBadgeProps) {
  if (count <= 0) return null;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="content-obligations-badge"
      className={cn(
        'text-sm text-muted-foreground hover:text-foreground transition-colors px-1.5 py-0.5 rounded',
        className
      )}
    >
      Obligations {count}
    </button>
  );
}
